module.exports = __webpack_public_path__ + "static/img/profile-target-2.0fcf8c8c.png";